import { Controller } from "@hotwired/stimulus"

/**
 * When a submit button is clicked, save all participant voting selections
 * (two-sided + statement + pie) first, then submit the form.
 * Use submitValues to specify which button values trigger this (e.g. "complete" or "complete,author").
 */
export default class extends Controller<HTMLButtonElement> {
  static values = {
    formId: { type: String, default: "quiz-form" },
    waitMs: { type: Number, default: 1500 },
    submitValues: { type: String, default: "complete" },
  }

  declare formIdValue: string
  declare waitMsValue: number
  declare submitValuesValue: string

  submitWithSave(event: Event) {
    const value = (this.element as HTMLButtonElement).value
    const allowed = this.submitValuesValue.split(",").map((v) => v.trim())
    if (!allowed.includes(value)) {
      return
    }

    event.preventDefault()

    const form = document.getElementById(this.formIdValue) as HTMLFormElement | null
    if (!form) {
      return
    }

    document.dispatchEvent(
      new CustomEvent("participant:saveSelectionsBeforeSubmit", { detail: { silent: true } }),
    )
    document.dispatchEvent(
      new CustomEvent("participant:savePieVotingSelections", { detail: { silent: true } }),
    )

    setTimeout(() => {
      form.requestSubmit(this.element)
    }, this.waitMsValue)
  }
}
